import { MARQUEE_ITEMS } from "@/config";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 border-y border-gold/15 bg-navy-800/60 backdrop-blur-sm py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee gap-0">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 pr-8 whitespace-nowrap font-mono text-xs sm:text-sm tracking-[0.25em] text-mist"
          >
            {item}
            <span className="text-gold text-base leading-none">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
